var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_768_35697)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_768_35697",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3327 5.8335C11.7009 5.8335 11.9993 6.13197 11.9993 6.50016V13.1668C11.9993 14.2714 11.1039 15.1668 9.99935 15.1668H5.99935C4.89478 15.1668 3.99935 14.2714 3.99935 13.1668V6.50016C3.99935 6.13197 4.29783 5.8335 4.66602 5.8335H11.3327ZM10.666 7.16683H5.33268V13.1668C5.33268 13.535 5.63116 13.8335 5.99935 13.8335H9.99935C10.3675 13.8335 10.666 13.535 10.666 13.1668V7.16683ZM5.99935 2.50016C5.99935 2.13197 6.29783 1.8335 6.66602 1.8335H9.33268C9.70087 1.8335 9.99935 2.13197 9.99935 2.50016V3.16683H12.666C13.0342 3.16683 13.3327 3.46531 13.3327 3.8335C13.3327 4.20169 13.0342 4.50016 12.666 4.50016H3.33268C2.96449 4.50016 2.66602 4.20169 2.66602 3.8335C2.66602 3.46531 2.96449 3.16683 3.33268 3.16683H5.99935V2.50016Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_768_35697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H16V16.5H0V0.5Z",
    fill: "#333333"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_768_35697"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashicon);
export default __webpack_public_path__ + "static/media/trashicon.ba9617ed.svg";
export { ForwardRef as ReactComponent };